import { render, staticRenderFns } from "./LeadersBoardWidget.vue?vue&type=template&id=64a6244e&scoped=true&"
import script from "./LeadersBoardWidget.vue?vue&type=script&lang=js&"
export * from "./LeadersBoardWidget.vue?vue&type=script&lang=js&"
import style0 from "./LeadersBoardWidget.vue?vue&type=style&index=0&id=64a6244e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a6244e",
  null
  
)

export default component.exports